import ImageSlider from "./ImageSlider";
import { nxplanSlides } from "../data/nxplan-slides";

export default function NxplanSlider(props) {
  const { slides, ...rest } = props || {};
  return (
    <ImageSlider
      slides={
        Array.isArray(slides) && slides.length > 0 ? slides : nxplanSlides
      }
      containerClass="max-w-6xl mx-auto"
      defaultLayout="split"
      {...rest}
    />
  );
}
